import { makeStyles } from "@material-ui/core";

const wizardGroupPayStyles = makeStyles(() => ({
  root: {
    '& .MuiStepIcon-root': { 
      color: '#7BB992 !important' 
    },
    '& .MuiStepIcon-root.MuiStepIcon-active': { 
      color: '#D5EFDD !important' 
    },
    '& .MuiStepIcon-root.MuiStepIcon-completed': { 
      color: '#A8D5BA !important' 
    },
    '& .MuiStepLabel-label.MuiStepLabel-active': { 
      color: '#A8D5BA !important' 
    },
    '& .MuiStepLabel-label.MuiStepLabel-completed': { 
      color: '#A8D5BA !important' 
    },
    '& .MuiStepConnector-line': { 
      borderColor: '#D5EFDD !important' 
    },
    '& .MuiStepConnector-root.MuiStepConnector-completed .MuiStepConnector-line': { 
      borderColor: '#D5EFDD !important' 
    },
    '& .MuiStep-root .MuiStepIcon-root': { 
      backgroundColor: '#D5EFDD !important'
    },
    '& .MuiButton-outlined': { 
      backgroundColor: '#f5f5f5 !important',
      color: '#666 !important',
      borderColor: '#ddd !important' 
    },
    '& .MuiButton-outlined:hover': { 
      backgroundColor: '#e0e0e0 !important',
      borderColor: '#bbb !important' 
    },
    '& .MuiButton-contained': {
      backgroundColor: '#83cf9c !important',
      color: '#fff !important',
      fontSize: '0.8rem !important',
      minWidth: '180px !important',
      paddingLeft: '48px !important',
      paddingRight: '48px !important',
      paddingTop: '8px !important',
      paddingBottom: '8px !important'
    },
    '& .MuiButton-contained:hover': { 
      backgroundColor: '#45a049 !important'  
    },
    '& .MuiButton-contained:disabled': {
      backgroundColor: '#b2b2b2 !important',
      color: '#fff !important',
      cursor: 'not-allowed',
      opacity: 1,
      boxShadow: 'none !important',
      fontSize: '0.8rem !important'
    },
    '& .MuiButton-contained:disabled:hover': {
      backgroundColor: '#D5EFDD !important',  
    }
  }
}));

export default wizardGroupPayStyles;